// Brand logo: transparent PNG cut from the client's PDF (see /app/scripts/brand/cutout.py). Set to null to fall back to the text wordmark.
export const BRAND_LOGO_SRC = "/brand/dalilshop-logo-480.png";
export const BRAND_LOGO_SRCSET = "/brand/dalilshop-logo-480.png 480w, /brand/dalilshop-logo-900.png 900w, /brand/dalilshop-logo.png 1431w";
export const BRAND_LOGO_SIZE = { width: 1431, height: 880 };
export const BRAND_NAME = "Da Lil Shop";
export const BRAND_TAGLINE = "Doing Big Things";
